import React from "react"
import { NotionRenderer, Code, Pdf } from 'react-notion-x'
import axios from 'axios'
// core styles shared by all of react-notion-x (required)
import 'react-notion-x/src/styles.css'

// used for code syntax highlighting (optional)
import 'prismjs/themes/prism-tomorrow.css'

// used for collection views (optional)
import 'rc-dropdown/assets/index.css'

// used for rendering equations (optional)
import 'katex/dist/katex.min.css'
class APIPage extends React.Component {
  constructor(props) {
    super(props); 
    this.state = {   
      recordMap: null
    }
  }

  componentDidMount() { 
    axios.get(`https://nakrutkatop.com:443/api/notion/getPage?id=Boostify-API-1409aedc2d4f4c2e8e3a9d4f0a1f2b1a`, { withCredentials: true })
      .then(res => {
        this.setState({recordMap: res.data})
      }
      )
    
  }

  render(props) {
    return <div className="mdc-drawer-app-content mdc-top-app-bar--fixed-adjust icontent" >
      {this.state.recordMap ? <NotionRenderer recordMap={this.state.recordMap} fullPage={true} darkMode={true} components={{code: Code, pdf: null}}/> : ''}
    </div>
  }
}

export default APIPage
